module.exports = __webpack_public_path__ + "28d25d8cce738455a9dc9ef3fbf796cb.jpg";